// extracted by mini-css-extract-plugin
export default {"dlOutputLabel":"src-js-components-OutputLabel---dlOutputLabel---cu5gU"};